import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { MiraieService } from './miraie.service';

@Injectable({
	providedIn: 'root'
})
export class CalendarService {

	constructor(
		private http: MiraieService,
	) { }

	/**
	 * 
	 */
	getEeventCal(division, year, month, day, login_user_id, is_all = null) {
		var url = "event/get";
		let param = {
			'division': division,
			'year': year,
			'month': month,
			'day': day,
			'login_user_id': login_user_id,
			'is_all': is_all
		};
		return this.http.post(url, param);
	}

	setEventCal(schedule, login_user_id) {
		//   schedule: {
		//    id:
		//    title:
		//    strat: 
		//    end:
		//    allDay:
		//    meta: {
		//      type:
		//      contents:
		//      other: {}
		//      division:
		//      holiday:
		//    },
		//    login_user_id:
		//  }
		var url = "event/set";
		let param = {
			'schedule': schedule,
			'login_user_id': login_user_id,
		};

		return this.http.post(url, param);
	}
	delEventCal(schedule, login_user_id) {
		var url = "event/del";
		let param = {
			'schedule': schedule,
			'login_user_id': login_user_id
		};

		return this.http.post(url, param);
	}

	getUserCal(user_id, division, year, month, day, login_user_id) {
		var url = "cal/get";
		//console.log('getUserCal', user_id, division, year, month, day, login_user_id);
		let param = {
			'user_id': user_id,
			'division': division,
			'year': year,
			'month': month,
			'day': day,
			'login_user_id': login_user_id,
		};

		return this.http.post(url, param);
	}

	setUserCal(user_id, schedule, login_user_id, baseid = '') {
		var url = "cal/set";
		let param = {
			'user_id': user_id,
			'schedule': schedule,
			'login_user_id': login_user_id,
			'baseid': baseid
		};

		return this.http.post(url, param);
	}
	delUserCal(schedule, login_user_id) {
		var url = "cal/del";
		let param = {
			'schedule': schedule,
			'login_user_id': login_user_id
		};

		return this.http.post(url, param);
	}
}
